import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f583e39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "queue-items" }
const _hoisted_2 = ["onDrop"]

import * as ticketProcessor from '@/ops/workspaces/ticket.processor'
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import TicketStrip from '@/components/Workspaces/tickets/_spec/TicketStrip.vue';
import sys from '@/sys';
import { computed } from 'vue';
import { dragEventRef, ticketInternal } from '@/controllers/workspaces/tickets/_spec/ticket.item.controller'
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { ITicketUiElementController } from '@/components/Workspaces/tickets/_spec/ticket.controller.elementary.interface'
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import { item as todoOrTicket } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model'
import { BlockRmodel } from '@/app.context/workspace/tickets/tasks/block.rmodel';
import { IFileStorage } from '@/io/storages';
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';


export default /*#__PURE__*/_defineComponent({
  __name: 'QueueComponent',
  props: {
    tickets: {},
    todos: {},
    title: {},
    level: {},
    prefix: {},
    circledX: { type: Boolean },
    controller: {},
    files: {},
    efforts: {}
  },
  emits: {
                x: null,
                v: null,
                drop: null,
                command: null,
                block: null,
                "click-strip": null,
                "person"(t: TicketRmodel | TodoRmodel, p: PersonRmodel, index: number | null) {
                        // perform runtime validation
                        return t != null && p != null
                }

        },
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

const items = computed(() => {

        return f();
})

function onFiles(item: { ticket?: TicketRmodel, todo?: TodoRmodel }, files: File[]) {

        const t = ticketInternal(item)

        const s = props.files

        if (s != null) {

                //if (t instanceof TodoRmodel) t = t.ticket

                ticketProcessor.addFiles(s, t.workspace.storage, t, files)
        }
}

function f(): { ticket?: TicketRmodel, todo?: TodoRmodel, key: string }[] {

        const result: { ticket?: TicketRmodel, todo?: TodoRmodel, key: string }[] = [];

        if (props.tickets != undefined) {

                props.tickets.forEach(t => result.push({ ticket: t, key: (props.prefix ?? '') + t.key }));
        }

        if (props.todos != undefined) {

                props.todos.forEach(t => result.push({ todo: t, key: (props.prefix ?? '') + t.key }));
        }

        return result;
}

function onStripClick(t: TodoRmodel | TicketRmodel, level: number) {

        emit('click-strip', t, level);
}

function onCloseClick(item: TodoRmodel | TicketRmodel) {

        props.controller?.close(item)

        emit('x', item)
}

function onCheckClick(item: TodoRmodel | TicketRmodel) {

        props.controller?.check(item)

        emit('v', item)
}

//onBlockClick
function onPersonClick(item: { todo?: TodoRmodel, ticket?: TicketRmodel }, person: PersonRmodel, index: number | null) {

        const x = todoOrTicket(item)

        if (x != null) {
                props.controller?.person(x, person, index)
                emit('person', x, person, index)
        }
}


function onBlockClick(item: BlockRmodel) {


        props.controller?.block(item)
        emit('block', item)

}


function stripOnDrop(e: DragEvent) {

        const target = e.target;

        const element = target as HTMLElement

        const parent = element.parentNode as HTMLElement

        return parent;
}

function onDrageEnter(e: DragEvent) {

        const element = stripOnDrop(e)

        element.classList.add('dev-box')
}

function onDragOver(e: DragEvent) {

        if (props.level != undefined && props.level >= TicketAccessLevel.Full) {
                e.preventDefault()

                const element = stripOnDrop(e)

                element.classList.add('dev-box')
        }
}

function onDragLeave(e: DragEvent) {

        const element = stripOnDrop(e)

        //element.parentNode.e

        element.classList.remove('dev-box')
}

//

function onDrop(e: DragEvent, index: number) {

        const element = stripOnDrop(e)

        element.classList.remove('dev-box')

        const ref = dragEventRef(e);

        if (ref != null) emit('drop', ref, index)
}

function onCommand(command: string, ticket: TicketRmodel) {

        emit('command', command, ticket)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (items.value.length == 0)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "empty",
            onDragenter: _withModifiers(onDrageEnter, ["prevent"]),
            onDragleave: onDragLeave,
            onDragover: _withModifiers(onDragOver, ["prevent"]),
            onDrop: _cache[0] || (_cache[0] = ($event: any) => (onDrop($event, 0)))
          }, null, 32))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "item",
          key: item.key,
          onDragenter: _withModifiers(onDrageEnter, ["prevent"]),
          onDragleave: onDragLeave,
          onDragover: onDragOver,
          onDrop: ($event: any) => (onDrop($event, index))
        }, [
          _createVNode(TicketStrip, {
            ticket: item.ticket,
            todo: item.todo,
            level: props.level,
            "circled-x": _ctx.circledX,
            onClick: onStripClick,
            onX: onCloseClick,
            onV: onCheckClick,
            onPerson: (p, i) => onPersonClick(item, p, i),
            onBlock: _cache[1] || (_cache[1] = (b) => onBlockClick(b)),
            onCommand: onCommand,
            onFiles: (f) => onFiles(item, f),
            efforts: _ctx.efforts
          }, null, 8, ["ticket", "todo", "level", "circled-x", "onPerson", "onFiles", "efforts"])
        ], 40, _hoisted_2))
      }), 128))
    ])
  ]))
}
}

})